import { Component, Input } from '@angular/core';
import { PhoneCall } from '@salesforce/scv-connector-base';

@Component({
  selector: 'app-active-call',
  templateUrl: './active-call.component.html',
  styleUrls: ['./active-call.component.css']
})
export class ActiveCallComponent {
  @Input({required: true}) phoneCall!: PhoneCall;
  @Input({required: true}) index!: number;
  isExpanded = false;
  isContactDetailsExpanded = false;
  isAttributesExpanded = false;
  isInfoExpanded = false;

  isCallHeld(): boolean {
    return Boolean(this.phoneCall.callAttributes.isOnHold);
  }

  toggleExpanded(): void {
    this.isExpanded = !this.isExpanded;
  }

  toggleContactExpanded(): void {
    this.isContactDetailsExpanded = !this.isContactDetailsExpanded;
  }

  toggleAttributesExpanded(): void {
    this.isAttributesExpanded = !this.isAttributesExpanded;
  }

  toggleInfoExpanded(): void {
    this.isInfoExpanded = !this.isInfoExpanded;
  }
}
